import { ManageMetadataTable } from '@modules/integrationsV2/components/ManageMetadataSection/ManageMetadataTable';
import { IntegrationSource } from '@modules/integrationsV2/types';
import { trackIntegrationPageEvent } from '@modules/integrationsV2/utils';
import { EditNoteRounded, ExpandMoreRounded } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  Typography,
} from '@mui/material';
import { IntegrationType } from 'generated/graphql';
import { useState } from 'react';

interface ManageMetadataSectionProps {
  integrationSource: IntegrationSource;
}

export const ManageMetadataSection = ({
  integrationSource,
}: ManageMetadataSectionProps) => {
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);

  // Cohort integrations don't have feedback metadata
  if (integrationSource.integrationType === IntegrationType.Cohorts) {
    return null;
  }

  const handleAccordionChange = (
    _: React.SyntheticEvent<Element, Event>,
    isExpanded: boolean,
  ) => {
    setIsAccordionExpanded(isExpanded);
    if (isExpanded) {
      trackIntegrationPageEvent({
        eventName: 'Integrations - Manage Metadata Card Expanded',
        integration: {
          channelType: integrationSource.channel.type,
          integrationType: integrationSource.integrationType,
          namespace: integrationSource.namespace,
        },
      });
    }
  };

  return (
    <Box>
      <Accordion
        disableGutters
        variant="outlined"
        expanded={isAccordionExpanded}
        onChange={handleAccordionChange}
        sx={{
          pt: 1,
          pb: isAccordionExpanded ? 0 : 1,
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreRounded fontSize="large" />}>
          <Stack spacing={1}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <EditNoteRounded
                sx={{
                  color: 'text.secondary',
                }}
              />
              <Typography>Manage Metadata</Typography>
            </Stack>
            <Typography variant="body2" color="text.secondary" pl={4}>
              Metadata fields are properties ingested along with feedback.
              Manage them to control how and when they show up.
            </Typography>
          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          {isAccordionExpanded && (
            <ManageMetadataTable integrationSource={integrationSource} />
          )}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
